<template>
    <credential-login-button provider="credential_user" :cognitoBaseUrl="cognitoBaseUrl" :cognitoClientId="cognitoClientId" icon="lock_outlined" :label="$t('LOGIN_CREDENTIAL_USER')" v-bind="$attrs" v-on="$listeners"/>
</template>

<script lang="ts">
import Vue from "vue";
import CredentialLoginButton from "./CredentialLoginButton.vue";
import Config from "@/config";
import Component from "vue-class-component";

@Component({
    components: { CredentialLoginButton }
})
export default class LoginButtons extends Vue
{
    get cognitoBaseUrl():string 
    {
        return Config.COGNITO_USER_POOL_BASE_URL;
    }

    get cognitoClientId():string 
    {
        return Config.COGNITO_USER_POOL_CLIENT_ID;
    }
}
</script>
